/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { action, observable } from 'mobx';
import { ModelType } from 'src/luis/types/ModelType';

export type CustomTextClassData = Omit<CustomTextClassStore, 'renameClass'>;
export class CustomTextClassStore {
    public readonly id: string;

    public readonly typeId: ModelType.Intent = ModelType.Intent;

    @observable public name: string;

    constructor(metadata: Partial<CustomTextClassData>) {
        this.name = metadata.name;
        this.id = metadata.id ?? getId();
    }

    /**
     * Renames the class
     * @param newName
     */
    @action
    public renameClass(className: string) {
        this.name = className;
    }
}
